module.exports = __webpack_public_path__ + "img/Kuwait.79a1826d.svg";